import { render, staticRenderFns } from "./Dispute.vue?vue&type=template&id=5e6c353c&scoped=true&"
import script from "./Dispute.vue?vue&type=script&lang=js&"
export * from "./Dispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c353c",
  null
  
)

export default component.exports